// B2B Sidebar Component - Reorganized Navigation
import { NavLink, useLocation } from 'react-router-dom';
import { useB2B } from '../context/B2BContext';

export default function B2BSidebar({ newLeadsCount = 0 }) {
  const { logout } = useB2B();
  const location = useLocation();

  // Helper to check if a settings tab is active
  const isSettingsTabActive = (tab) => {
    const params = new URLSearchParams(location.search);
    const currentTab = params.get('tab');
    return location.pathname === '/b2b/settings' && currentTab === tab;
  };

  return (
    <aside className="b2b-sidebar">
      <NavLink 
        to="/b2b" 
        end
        className={({ isActive }) => `b2b-nav-item ${isActive ? 'active' : ''}`}
      >
        <span className="icon">📊</span>
        Dashboard
      </NavLink>
      
      <NavLink 
        to="/b2b/leads"
        className={({ isActive }) => `b2b-nav-item ${isActive ? 'active' : ''}`}
      >
        <span className="icon">👥</span>
        Leads
        {newLeadsCount > 0 && (
          <span className="b2b-nav-badge">{newLeadsCount}</span>
        )}
      </NavLink>
      
      {/* ════════════════════════════════════════════════════════════
          WIDGET SECTION
      ════════════════════════════════════════════════════════════ */}
      <div className="b2b-sidebar-divider" />
      <div className="b2b-sidebar-section">Widget</div>
      
      <NavLink 
        to="/b2b/widget-content"
        className={({ isActive }) => `b2b-nav-item ${isActive ? 'active' : ''}`}
      >
        <span className="icon">🎯</span>
        Content
      </NavLink>
      
      <NavLink 
        to="/b2b/settings?tab=branding"
        className={() => `b2b-nav-item ${isSettingsTabActive('branding') || (location.pathname === '/b2b/settings' && !location.search) ? 'active' : ''}`}
      >
        <span className="icon">🎨</span>
        Branding
      </NavLink>
      
      <NavLink 
        to="/b2b/settings?tab=widget"
        className={() => `b2b-nav-item ${isSettingsTabActive('widget') ? 'active' : ''}`}
      >
        <span className="icon">💬</span>
        Widget Settings
      </NavLink>
      
      <NavLink 
        to="/b2b/settings?tab=ai"
        className={() => `b2b-nav-item ${isSettingsTabActive('ai') ? 'active' : ''}`}
      >
        <span className="icon">🧠</span>
        AI Settings
      </NavLink>
      
      <NavLink 
        to="/b2b/settings?tab=embed"
        className={() => `b2b-nav-item ${isSettingsTabActive('embed') ? 'active' : ''}`}
      >
        <span className="icon">🔗</span>
        Embed Code
      </NavLink>

      {/* ════════════════════════════════════════════════════════════
          ACCOUNT SECTION
      ════════════════════════════════════════════════════════════ */}
      <div className="b2b-sidebar-divider" />
      <div className="b2b-sidebar-section">Account</div>
      
      <NavLink 
        to="/b2b/settings?tab=notifications"
        className={() => `b2b-nav-item ${isSettingsTabActive('notifications') ? 'active' : ''}`}
      >
        <span className="icon">🔔</span>
        Notifications
      </NavLink>
      
      <NavLink 
        to="/b2b/billing"
        className={({ isActive }) => `b2b-nav-item ${isActive ? 'active' : ''}`}
      >
        <span className="icon">💳</span>
        Billing
      </NavLink>
      
      <div className="b2b-sidebar-divider" />
      
      <button 
        className="b2b-nav-item"
        onClick={logout}
        style={{ marginTop: 'auto' }}
      >
        <span className="icon">🚪</span>
        Sign Out
      </button>
    </aside>
  );
}
